import { SKU_CATEGORY } from '../../../Contexts/PaymentProvider/PaymentProvider.d';

const mapGTMProductType = (
  productType?: SKU_CATEGORY,
  googleEcommerceSKUCategoryMap?: Record<SKU_CATEGORY, string>
) => {
  let _googleEcommerceSKUCategoryMap = googleEcommerceSKUCategoryMap;

  if (!_googleEcommerceSKUCategoryMap) {
    _googleEcommerceSKUCategoryMap = {
      ALL: 'N/A',
      WORKSHOP: 'N/A',
      WORKSHOP_BATCH: 'WORKSHOP',
      ONLINE_COURSE: 'COURSE',
      SUBSCRIPTION: 'N/A',
      COLLECTION: 'BUNDLE',
      BOOK: 'N/A',
      MERCHANDISE: 'N/A',
    };
  }

  const ecommerceProductType = productType ? _googleEcommerceSKUCategoryMap[productType] : null;
  return ecommerceProductType ? ecommerceProductType : 'N/A';
};

export default mapGTMProductType;
